import { useCallback } from 'react';
import { selectCanUseLoyalty } from '../reducers/offerOptions';
import { selectCurrentVehicle } from '../reducers/currentVehicle';
import { selectPrimaryCalculatorLoyaltyOfferKey } from '../reducers/financialCalculators';
import { useAppSelector } from '../utils';
export default function useSelectLoyaltyOfferKeyByTrim(defaultLoyaltyOfferKey = '', isPrimaryCalculator = true) {
    const primaryCalculatorLoyaltyOfferKey = useAppSelector(selectPrimaryCalculatorLoyaltyOfferKey);
    const canUseLoyalty = useAppSelector(selectCanUseLoyalty);
    const { trimKey: currentTrimKey } = useAppSelector(selectCurrentVehicle);
    return useCallback((trimKey) => canUseLoyalty
        ? (isPrimaryCalculator && currentTrimKey && currentTrimKey === trimKey && primaryCalculatorLoyaltyOfferKey) ||
            defaultLoyaltyOfferKey
        : '', [primaryCalculatorLoyaltyOfferKey, currentTrimKey, defaultLoyaltyOfferKey, isPrimaryCalculator, canUseLoyalty]);
}
